import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'react-router-redux';
import { LocalizeProvider } from "react-localize-redux";

import App from './components/App/App';
import history from './utils/History.js'
import configureStore from './store/configureStore';
import { actionCreators as accountActions } from './store/Account';
import { actionCreators as themeOptionsActions } from './store/Theme';



// Get the application-wide store instance, prepopulating with state from the server where available.
const persitedState = window.initialReduxState;

const store = configureStore(history, persitedState);

store.dispatch(accountActions.init());
store.dispatch(themeOptionsActions.init());

const rootElement = document.getElementById('root');

ReactDOM.render(
	<Provider store={store}>
		<LocalizeProvider store={store}>
			<ConnectedRouter history={history}>
				<App />
			</ConnectedRouter>
		</LocalizeProvider>
	</Provider>, rootElement);


// WEBPACK FOOTER //
// ./src/index.js